export default __webpack_public_path__ + "static/media/remoteActive.8320c962.png";